const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ae096314e207aada92aaec62797fb8fb1e369d94"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gardens@1hive-6w"]={id:"ae096314e207aada92aaec62797fb8fb1e369d94"};
      